import { render, staticRenderFns } from "./SupplierListCreate.vue?vue&type=template&id=039a2e0a&scoped=true"
import script from "./SupplierListCreate.vue?vue&type=script&lang=js"
export * from "./SupplierListCreate.vue?vue&type=script&lang=js"
import style0 from "./SupplierListCreate.vue?vue&type=style&index=0&id=039a2e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a2e0a",
  null
  
)

export default component.exports